import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
const { dbCommercial } = en;

export default function MfFailure(props: any) {
    return (
        <div className="curved-bg mf-success">
            <div className="curved-bg-content nct-success-screen nct-failed-screen">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <img
                            className="change-email-img"
                            src="/images/mf-failure-character.png"
                            alt=""
                        />
                        <h3 className="subheading">
                            {dbCommercial.exploreMfs.failureScreen.heading}
                        </h3>
                        <p>{dbCommercial.exploreMfs.failureScreen.headingInfo}</p>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <div className="mf-investment-summary">
                            <h4>{dbCommercial.exploreMfs.successScreen.investmentSummary}</h4>
                            <div className="mf-investment-summary-info">
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.scheme}</p>
                                    <h5>Nippon India Nifty Smallcap 250 Index Fund Reg Gr</h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.panNo}</p>
                                    <h5>AVEOY9087K </h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.folio}</p>
                                    <h5>23456123454</h5>
                                </div>
                            </div>
                            <div className="mf-investment-summary-info">
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.investmentType}</p>
                                    <h5>Lumpsum</h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.investmentAmount}</p>
                                    <h5>₹ 5,000 </h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.paymentMode}</p>
                                    <h5>Net Banking</h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.date}</p>
                                    <h5>27 Dec 2021, 12:30PM </h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.Id}</p>
                                    <h5>Trans-1234562611</h5>
                                </div>
                            </div>
                        </div>
                        <Button
                            className="customBtn"
                            onClick={() => props.history.push('/portal/commercial')}
                        >
                            {dbCommercial.exploreMfs.successScreen.goToTransact}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
